import { useEffect } from 'react';
import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import ApplyFlexiLoanFormView from './applyFlexiLoanFormView/ApplyFlexiLoanFormView';
import {
    ACTIVATE_APPLY_FLEXI_LOAN,
    DEACTIVATE_APPLY_FLEXI_LOAN
} from './ApplyFlexiLoanView.actions';
import { useStateKey } from '../../iwQueryClient/useStateKey';
import { trackPageView } from '../../tracking/pageView';

const mapDispatchToProps = (dispatch: Dispatch) => ({
    activate: () => dispatch({ type: ACTIVATE_APPLY_FLEXI_LOAN }),
    deactivate: () => dispatch({ type: DEACTIVATE_APPLY_FLEXI_LOAN })
});

const ApplyFlexiLoanView = ({
    activate,
    deactivate
}: ReturnType<typeof mapDispatchToProps>) => {
    const stateKey = useStateKey();

    useEffect(() => {
        activate();

        return () => {
            deactivate();
        };
    }, [activate, deactivate]);

    useEffect(() => {
        if (stateKey) {
            trackPageView(stateKey, 'Apply Flexi Loan');
        }
    }, [stateKey]);

    return <ApplyFlexiLoanFormView />;
};

// eslint-disable-next-line import/no-default-export
export default connect(undefined, mapDispatchToProps)(ApplyFlexiLoanView);
